module.exports = __webpack_public_path__ + "static/img/shipingaoliang.9df599db.svg";